<div class="title">{{ title }}</div>
<div class="description">{{ description }}</div>
